module.exports = __webpack_public_path__ + "static/media/cob.c6669d6d.svg";